import styled from '@emotion/styled'
import { Flex } from 'rebass'

import GamePlay from './pages/GamePlay/GamePlay'
import GameModeContext from './utils/GameModeContext'

const AppContainer = styled(Flex)`
  align-items: center;
  justify-content: center;
  height: 90vh;
`

function App() {
  return (
    <AppContainer>
      <GameModeContext>
        <GamePlay />
      </GameModeContext>
    </AppContainer>
  )
}

export default App
